import { Box, Button, ClickAwayListener, Typography } from '@mui/material';
import React, { useState } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useNavigate } from 'react-router';

export const DropdownActionLkp = ({
  authorizeAction,
  item,
  handleOpenAlert,
  handleOpenAssign,
  handleOpenConfirmDelete,
}) => {
  const navigate = useNavigate();
  const [isActionOpen, setIsActionOpen] = useState(false);
  const [hover, setHover] = useState(false);

  const renderActions = () => {
    const Col = ({ text, onClick }) => (
      <Typography
        onClick={onClick}
        sx={{
          px: 1,
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.1)',
          },
        }}
      >
        {text}
      </Typography>
    );

    return (
      <>
        {item.isStatus === 'A' ? (
          <Col
            text="View LKP"
            onClick={() => navigate(`/hsse/incident/${item.paramLkpEncode}`)}
          />
        ) : null}

        {item.isStatus === 'A' &&
        authorizeAction.lkP_CREATE_LKPDECISSION === true &&
        item.statusLkp === 'Issued' &&
        item.perluInsidentAlert === null &&
        item.perluDilakukanInvestigasi === null ? (
          <Col
            text="Make Decision"
            onClick={() =>
              navigate(`/hsse/incident/lkpdecision/${item.paramLkpEncode}`)
            }
          />
        ) : null}
        {item.isStatus === 'A' &&
        authorizeAction.lkP_CREATE_INCIDENTALERT === true &&
        item.perluInsidentAlert === true &&
        !item.idIncidentAlert ? (
          <Col
            text="Create Incident Alert"
            onClick={() => handleOpenAlert(item, 'Incident Alert', 'Create')}
          />
        ) : null}
        {item.isStatus === 'A' &&
        authorizeAction.lkP_CREATE_LKPDECISSION === true &&
        //item.statusLkp === 'Issued' &&
        item.perluInsidentAlert !== null &&
        item.perluDilakukanInvestigasi !== null ? (
          <Col
            text="View Decision"
            onClick={() =>
              navigate(`/hsse/incident/lkpdecision/${item.paramLkpEncode}`)
            }
          />
        ) : null}
        {item.isStatus === 'A' &&
        authorizeAction.lkP_CREATE_INCIDENTALERT === true &&
        item.perluInsidentAlert === true &&
        !item.idIncidentAlert ? (
          <Col
            text="Create Incident Alert"
            onClick={() => handleOpenAlert(item, 'Incident Alert', 'Create')}
          />
        ) : null}
        {item.isStatus === 'A' &&
        authorizeAction.lkP_VIEW_INCIDENTALERT === true &&
        item.perluInsidentAlert === true &&
        item.idIncidentAlert ? (
          <Col
            text="View Incident Alert"
            onClick={() => handleOpenAlert(item, 'Incident Alert', 'View')}
          />
        ) : null}
        {item.isStatus === 'A' &&
        authorizeAction.lkP_CREATE_ASSIGNPICLAPINVEST === true &&
        item.perluDilakukanInvestigasi === true &&
        item.picLapInvest === null ? (
          <Col
            text="Assign PIC Lap. Investigasi"
            onClick={() =>
              handleOpenAssign(item, 'Assign PIC Laporan Investigasi', 'Create')
            }
          />
        ) : null}
        {item.isStatus === 'A' &&
        item.alowLapInvest === true &&
        item.perluDilakukanInvestigasi === true &&
        item.picLapInvest &&
        !item.idTblLkpLaporanInvestigasi ? (
          <Col
            text="Create Lap. Invest"
            onClick={() =>
              navigate(
                `/hsse/incident/lapinvestigasi/create/${item.paramInvestigasiEncode}`,
                {
                  state: { data: item },
                }
              )
            }
          />
        ) : null}
        {item.isStatus === 'A' &&
        item.alowLapInvest === true &&
        item.perluDilakukanInvestigasi === true &&
        item.idTblLkpLaporanInvestigasi ? (
          <Col
            text="View Lap. Invest"
            onClick={() =>
              navigate(
                `/hsse/incident/lapinvestigasi/view/${item.paramInvestigasiEncode}`,
                {
                  state: { data: { ...item, isEditMode: true } },
                }
              )
            }
          />
        ) : null}
        {item.isStatus === 'A' &&
        authorizeAction.lkP_CREATE_LFE === true &&
        item.statusInvestigasi === 'Completed' &&
        !item.idLearningFromEvent ? (
          <Col
            text="Create Learning Event"
            onClick={() => handleOpenAlert(item, 'Learning Event', 'Create')}
          />
        ) : null}
        {item.isStatus === 'A' &&
        authorizeAction.lkP_VIEW_LFE === true &&
        item.statusInvestigasi === 'Completed' &&
        item.idLearningFromEvent ? (
          <Col
            text="View Learning Event"
            onClick={() => handleOpenAlert(item, 'Learning Event', 'View')}
          />
        ) : null}
        {item.isStatus === 'A' &&
        authorizeAction.lkP_DELETE_LKPREVIEWED === true ? (
          <Col
            text="Delete LKP"
            onClick={() =>
              handleOpenConfirmDelete(item, 'Learning Event', 'View')
            }
          />
        ) : null}
        {authorizeAction.lkP_DELETE_LKPREVIEWED === true &&
        item.isStatus === 'I' ? (
          <Col
            text="View Deleted Info"
            onClick={() =>
              handleOpenConfirmDelete(item, 'Learning Event', 'View')
            }
          />
        ) : null}
      </>
    );
  };

  return (
    <Box sx={{ position: 'relative' }}>
      <div
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onClick={() => setIsActionOpen(true)}
        style={{
          backgroundColor: '#1c734a',
          borderColor: '#7cab9a',
          border: hover ? '2px solid #7cab9a' : '2px solid #fff',
          borderRadius: 5,
          padding: '6px 0',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          cursor: 'pointer',
          color: '#fff',
          display: 'flex',
          width: '95px',
        }}
      >
        Action
        <ArrowDropDownIcon />
      </div>
      {isActionOpen ? (
        <ClickAwayListener onClickAway={() => setIsActionOpen(false)}>
          <Box
            width={180}
            sx={{
              position: 'absolute',
              top: 35,
              right: 0,
              left: 0,
              zIndex: 1,
              borderRadius: 2,
              border: '1px solid #E3E3ED',
              py: 1,
              backgroundColor: '#fff',
            }}
          >
            {renderActions()}
          </Box>
        </ClickAwayListener>
      ) : null}
    </Box>
  );
};
